import sanityClient from '@sanity/client'

export default sanityClient({
    projectId: "s1sw7g3s",
    dataset: "production",
})

